import React, { useEffect } from 'react';
import HomeIndex from 'components/home';
import Footer from 'components/footer';
import Header from 'components/header';
import GuestMain from 'components/home/guest-login';
import { useSelector } from 'react-redux';

const HomeMain = (props) => {

    const guest = useSelector(state => state.session.guest);

    return (
        <React.Fragment>
            <React.Fragment>
                <Header />
                <HomeIndex {...props} />
                <Footer />
            </React.Fragment>
            {/* // {guest?.isAuthenticated ?
                <
        // :
        //     <GuestMain />
        // } */}
        </React.Fragment >
    )
}

export default HomeMain;